














import Vue from 'vue';
import Component from 'vue-class-component';
import {
  challengeModule,
  timelineInteractionModule,
  timelineInteractionState,
  timelineModule,
  timelineRepliesModule,
  timelineRepliesState,
  timelineState,
  userModule
} from '@/utils/store-acessor';
import moment from 'moment-timezone';
import {ChallengeModel} from '@/models/challenge.model';
import ReplyForm from '@/components/Challenges/tabs/timeline/ReplyForm.vue';
import {UserModel} from '@/models/user.model';
import OpenFileButton from '@/components/Shared/buttons/OpenFileButton.vue';
import TimelineUserWithPrivilegesInteraction
  from '@/components/Challenges/tabs/timeline/TimelineUserWithPrivilegesInteraction.vue';
import TimelineContestantInteraction from '@/components/Challenges/tabs/timeline/TimelineContestantInteraction.vue';
import TimelineItemCard from '@/components/Challenges/tabs/timeline/TimelineItemCard.vue';
import {TimelineModel} from '@/models/timeline.model';

@Component({
  components: {
    TimelineItemCard,
    TimelineContestantInteraction,
    TimelineUserWithPrivilegesInteraction,
    OpenFileButton,
    ReplyForm
  }
})
export default class TimelineInteraction extends Vue {
  @timelineModule.Getter('timelineById') timeline!: (id: number) => TimelineModel | undefined;
  @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
  @userModule.Getter('user') user!: UserModel;
  @challengeModule.Getter('hasPrivilegeAccess') isUserWithPrivileges!: boolean;
  @challengeModule.Getter('isContestant') isContestant!: boolean;
  @userModule.Getter('timezone') timezone!: string;

  loading = false;
  hasMany = false;

  async mounted() {
    timelineRepliesState.resetAllReplies();
    const id = this.$route.params.id;
    if (!id) {
      return;
    }
    if (this.challenge?.id) {
      await timelineState.fetchTimeline(this.challenge.id);
    }
    if (this.timeline(Number(id))?.id && this.challenge?.id) {
      await timelineInteractionState.fetchAll({
        challengerId: this.challenge?.id,
        timelineId: Number(id),
      });
    }
  }

  chargeReplies(interactionId: number) {
    const id = this.$route.params.id;
    if (this.timeline(Number(id)) && this.challenge?.id) {
      timelineRepliesState.fetchAll({
        challengerId: this.challenge.id,
        timelineId: Number(id),
        interactionId: interactionId
      }).then((d) => {
        this.hasMany = d.length > 0;
      });
    }
  }

  isActive(): boolean {
    const id = this.$route.params.id;
    if (!id) {
      return false;
    }
    const item = this.timeline(Number(id));
    if (!item) {
      return false;
    }
    const start = moment(item.start_at).tz(this.timezone);
    const finish = moment(item.finish_at).tz(this.timezone);
    const current = moment(new Date()).tz(this.timezone);
    // return start.isSameOrBefore(current) && finish.isSameOrAfter(current);
    return true;
  }

  notYetStarted(): boolean {
    const id = this.$route.params.id;
    if (!id) {
      return false;
    }
    const item = this.timeline(Number(id));
    if (!item) {
      return false;
    }
    const start = moment(item.start_at).tz(this.timezone);
    const current = moment(new Date()).tz(this.timezone);
    return start.isSameOrAfter(current)
  }

}
